import Vue from "vue";

const state = {
	_invoiceprevision_loading: 0,
};

const getters = {
	invoiceprevision_loading: (state) => state._invoiceprevision_loading !== 0,
};

const actions = {
	updateInvoicePrevision({ commit, dispatch }, data) {
		commit("START_INVOICEPREVISION_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/invoiceprevision", data)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_INVOICEPREVISION_LOADING");
				});
		});
	},
};
const mutations = {
	START_INVOICEPREVISION_LOADING(state) {
		state._invoiceprevision_loading++;
	},
	STOP_INVOICEPREVISION_LOADING(state) {
		state._invoiceprevision_loading--;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
